import { orderTypes } from "../../constants";

 const ordersConfig = {
   listOrdersDefaultSize: 5,
   latestOrdersDefaultSize: 5
 };

export const transactionTypeFilterButtons = [
  { label: "All", type: null },
  { label: "Buy", type: orderTypes.BUY },
  { label: "Sell", type: orderTypes.SELL }
];

export default ordersConfig;